// src/components/list/PanelDisplayNames.tsx

import { HomeTwoTone, MemoryTwoTone } from '@mui/icons-material'
import {
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  SxProps,
} from '@mui/material'

import { colorSchemeConsumption } from '../../api'

type Props = {
  data: string[]
  type: 'sensor' | 'folder'
  colors?: Record<string, string>
  sx?: SxProps
}

export const PanelDisplayNames = ({ data, type, colors, ...rest }: Props) => (
  <List sx={{ bgcolor: 'green' }} {...rest}>
    {data.map((name, key) => {
      const color =
        colors?.[name] ??
        colorSchemeConsumption[key % colorSchemeConsumption.length]
      const icon = type === 'sensor' ? <MemoryTwoTone /> : <HomeTwoTone />

      return (
        <ListItem key={name}>
          <ListItemIcon sx={{ color }}>{icon}</ListItemIcon>

          <ListItemText primary={name} />
        </ListItem>
      )
    })}
  </List>
)
